<template>
  <tr class="expertColor" :style="cssProps">
    <td class="col-md-2 col-xs-2" style="vertical-align: middle;" id="expert">
      {{ author.lastName }}, {{ author.firstName }}
    </td>

    <td v-if="author.affiliation" class="col-md-3 col-xs-3" style="vertical-align: middle" id="country-affiliation">
      <table class="table expertColor" style="width: 100%;">
        <td class="col-xs-4 col-md-4 text-center" style="vertical-align: middle">
          <flag v-if="author.affiliation && author.affiliation.organisationID" :squared="false" :iso="getIso(author.affiliation)" style="height: 100%"/>
        </td>
        <td class="col-xs-8 col-md-8" v-if="author.affiliation && author.affiliation.organisationID" style="">{{author.affiliation.organisationName | truncate(50)}}</td>
      </table>
    </td>
    <td v-else class="col-md-3 col-xs-3 " style="vertical-align: middle" id="country-affiliation">
      <table v-if="author.expertSource === 'BICWORLD'" class="table" style="width: 100%;">
        <td class="col-xs-4 col-md-4 text-center" style="vertical-align: middle"></td>
        <td class="col-md-8 col-xs-8" style="">Bic - Confluence</td>
      </table>
    </td>

    <td class="col-md-4 col-xs-4" id="top-document-title">
      <template v-if="author.expertSource === 'TECHNICAL EDISON'">
        <div v-html="topDocument.title"></div>
      </template>
      <div v-else-if="author.expertSource === 'BICWORLD'" v-html="topDocument.title"></div>
    </td>

    <td class="col-md-1 col-xs-1 text-center se" id="expert-score" style="vertical-align: center">
      <select :id="'score-'+ author.authorID">
        <option value="3">3</option>
        <option value="2">2</option>
        <option value="1">1</option>
      </select>
    </td>

    <td class="col-md-1 col-xs-1 text-center" style="vertical-align: middle;" ref="actions">
      <i class="fa fa-file-archive-o expertColor" style="font-size: 20px" data-toggle="popover" :data-content="'internal document'"></i>
    </td>
    <td class="col-md-1 col-sm-1 text-center" style="vertical-align: middle" id="expert-action">
      <div v-if="author.expertSource === 'TECHNICAL EDISON'">
        <a :href="'mailto:' + author.email" class="btn btn btn-xs btn-success">Mail to</a>
      </div>
    </td>
  </tr>
</template>

<style scoped>
.expertColor {
  color: var(--color);
}
</style>
<style>
.se .br-theme-bars-horizontal .br-widget a {
  height: 10px;
  background-color: var(--rating-color);
  /*background-color: rgba(0, 123, 225, 0.3);*/

}

.se .br-theme-bars-horizontal .br-widget a.br-active, .se .br-theme-bars-horizontal .br-widget a.br-selected {
  background-color: var(--expert-color);
}
</style>
<script>
import 'jquery-bar-rating/dist/jquery.barrating.min'
import DropdownAuthor from './DropdownAuthor'
import {convertHex} from '../../assets/scripts/utils'
import 'jquery-bar-rating/dist/themes/bars-horizontal.css'
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en.json'

IsoCountries.registerLocale(EnCountries)

export default {
  components: {DropdownAuthor},
  name: 'InternalAuthorTop',
  props: ['value'],
  data () {
    return {
      author: null,
      topDocument: null,
      color: '6a6c6f'
    }
  },
  computed: {
    cssProps () {
      return {
        '--color': '#' + this.color,
        '--rating-color': convertHex('#' + this.color, 0.3)
      }
    }
  },
  watch: {
    value: function (val) {
      this.author = val
    },
    author: function (val, oldVal) {
      if (typeof this.$refs.actions !== 'undefined') {
        $(this.$refs.actions).find('[data-toggle="popover"]').popover({
          trigger: 'hover',
          placement: 'top'
        })
      }

      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    initScore: (author) => {
      let scoreElement = $('#score-' + author.authorID)

      scoreElement.barrating({
        theme: 'bars-horizontal',
        readonly: true,
        showSelectedRating: false,
        hoverState: false,
        reverse: true,
        initialRating: 0.1
      })
    },
    getIso: (affiliation) => {
      if (typeof affiliation !== 'undefined') {
        let iso = IsoCountries.getAlpha2Code(affiliation.country, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(affiliation.code)
        }
        return iso
      }
    }
  },
  updated () {
    this.topDocument = this.author.docs[0]
    this.initScore(this.author)
  },
  mounted () {
    this.initScore(this.author)
  },
  beforeMount () {
    this.author = this.value

    this.author.docs.sort(function (doc1, doc2) {
      return new Date(doc2.createdAt) - new Date(doc1.createdAt)
    })
    this.topDocument = this.author.docs[0]

    this.color = this.$auth.user().profile.color_expert
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/InternalAuthorTop.vue